import { createQuery, createSafeInvalidateQueries } from '../common';
import * as apis from '../apis';

async function queryCriticalEvents() {
  const criticalEvents = await apis.getCriticalEvents();

  const criticalEventMap = criticalEvents.reduce((acc, it) => {
    acc.set(it.id, it);
    return acc;
  }, new Map<string, (typeof criticalEvents)[0]>());

  const criticalEventOptions = criticalEvents.map((it) => ({
    label: it.name,
    value: it.id,
  }));

  return { criticalEvents, criticalEventMap, criticalEventOptions };
}

export const QUERY_KEY_CRITICAL_EVENTS = `/gm/v1/critical_events` as const;

export const useCriticalEvents = createQuery({
  queryKey: [QUERY_KEY_CRITICAL_EVENTS],
  queryFn: queryCriticalEvents,
  cacheTime: Infinity,
  staleTime: Infinity,
});

export const useCriticalEvent = createQuery((id: string) => ({
  queryKey: [QUERY_KEY_CRITICAL_EVENTS, id],
  queryFn: () => apis.getCriticalEvent(id),
  enabled: !!id,
  staleTime: 0,
}));

export const invalidateCriticalEventsQuery = createSafeInvalidateQueries({
  queryKey: [QUERY_KEY_CRITICAL_EVENTS],
});
